/**
 * @hidden
 */
export var FIELD_REGEX = /\[(?:(\d+)|['"](.*?)['"])\]|((?:(?!\[.*?\]|\.).)+)/g;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-animation/node_modules/@progress/kendo-react-common/dist/es/constants/index.js
// module id = 111
// module chunks = 0